// Product Trust Badges Start

$(".ptb-item-wrapper").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    arrows: false,
    dots: false,
    cssEase: "linear",
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
});

// Product Trust Badges End

// Natural Ingredients Start

$(".ni-grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
            },
        }
    ],
});

// Natural Ingredients End

// Problem Highlights Start

$(".ph-grid").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                centerMode: true,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
            },
        }
    ],
});

// Problem Highlights End



// Main Product SLider Start 

  $(".main-product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite:false,
    asNavFor: '.thumbnail-product-slider',
    prevArrow:'<button type="button" class="slick-prev"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5186 9.99973H3.48152M3.48152 9.99973L8.37041 5.11084M3.48152 9.99973L8.37041 14.8886" stroke="#103D23" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.48145 9.99973H16.5185M16.5185 9.99973L11.6296 5.11084M16.5185 9.99973L11.6296 14.8886" stroke="#103D23" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'   
});

$(".thumbnail-product-slider").slick({
    slidesToShow: 4.3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite:false,
    asNavFor: '.main-product-slider',
    focusOnSelect: true,
     responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4.3,
      }
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 5.6,
      }
    }
  ]
});


document.addEventListener("DOMContentLoaded", () => {
  const desc = document.getElementById("short_description");
  const full = desc.textContent.trim();
  const limit = 230;

  if (full.length > limit) {
    const before = full.slice(0, limit);
    const after = full.slice(limit);

    desc.innerHTML = `${before}<span class="more-btn read_toggle_btn"> Read More</span><span class="hidden-text" style="display:none;">${after}</span>`;

    desc.addEventListener("click", e => {
      if (e.target.classList.contains("more-btn")) {
        const hidden = desc.querySelector(".hidden-text");
        hidden.style.display = "inline";
        e.target.remove();
        desc.insertAdjacentHTML("beforeend", `<div class="less-btn read_toggle_btn">Read Less</div>`);
      } else if (e.target.classList.contains("less-btn")) {
        desc.innerHTML = `${before}<span class="more-btn read_toggle_btn"> Read More</span><span class="hidden-text" style="display:none;">${after}</span>`;
      }
    });
  }
});

// PRODUCT ACCORDION JS START
$(document).ready(function(){
    $(".accordion-header").click(function(){
        $(this).parent(".main-accordion-box").toggleClass("active");
        $(this).next(".accordion-body").slideToggle();
    });
});
// PRODUCT ACCORDION JS END

// Main Product SLider End 

// Testimonial-section Start 

$(document).ready(function(){
    $('.tvs-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: true,
        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"> <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M21.1484 12.9998H4.85214M4.85214 12.9998L10.9633 6.88867M4.85214 12.9998L10.9633 19.1109"stroke="#103D23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M4.85156 12.9998H21.1479M21.1479 12.9998L15.0367 6.88867M21.1479 12.9998L15.0367 19.1109"stroke="#103D23" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: { 
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: { 
                    slidesToShow: 1 ,
                    centerMode:true,
                    arrows: false,
                }
            }
        ]
    });
});


document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".tvs-video-wrapper");

  wrappers.forEach(w => {
    const v = w.querySelector("video"),
          btn = w.querySelector(".tvs-play-btn"),
          playI = w.querySelector(".play-icon"),
          pauseI = w.querySelector(".pause-icon"),
          card = w.closest(".tvs-card"),
          info = card.querySelector(".tvs-info");

    pauseI.style.display = "none";
    card.classList.add("paused");

    const setState = (isPlay) => {
      playI.style.display = isPlay ? "none" : "block";
      pauseI.style.display = isPlay ? "block" : "none";
      card.classList.toggle("playing", isPlay);
      card.classList.toggle("paused", !isPlay);
      if (info) info.style.display = isPlay ? "none" : "block";
    };

    btn.addEventListener("click", () => {
      if (v.paused) {
        wrappers.forEach(o => {
          const ov = o.querySelector("video");
          if (!ov.paused && ov !== v) {
            ov.pause();
            o.querySelector(".play-icon").style.display = "block";
            o.querySelector(".pause-icon").style.display = "none";
            const oc = o.closest(".tvs-card");
            oc.classList.remove("playing"); oc.classList.add("paused");
            const oi = oc.querySelector(".tvs-info"); if (oi) oi.style.display = "block";
          }
        });
        v.play(); setState(true);
      } else {
        v.pause(); setState(false);
      }
    });

    v.addEventListener("ended", () => setState(false));
  });
});








// Testimonial-section End